import React from "react";

import { templates } from "@reactivated";

import { BackgroundStyle } from "../components/BackgroundStyle";
import { PageSkeleton } from "../components/PageSkeleton";
import { Toolbox } from "../components/Toolbox";

export const Template = (props: templates.ContactUsPageLandingPageTemplate) => (
    <React.StrictMode>
        <PageSkeleton {...props.page} enableChatBot>
            <BackgroundStyle style="wood-texture">
                <Toolbox value={props.page.body.value} />
                <Toolbox value={props.page.confirmation_content.value} />
            </BackgroundStyle>
        </PageSkeleton>
    </React.StrictMode>
);
